"use strict";
// Typescript definitions for types relating to progress. Note that many
// of these are "duplicated" by `/templates/progress/progressTypes, which defined
// these using PropTypes for usage in Javascript React components. As we move towards
// typescript we can deprecate the PropTypes definitions and use these instead.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewType = exports.ReviewStates = exports.PUZZLE_PAGE_NONE = void 0;
/**
 * See ApplicationHelper::PUZZLE_PAGE_NONE.
 */
exports.PUZZLE_PAGE_NONE = -1;
exports.ReviewStates = {
    completed: 'completed',
    keepWorking: 'keepWorking',
    awaitingReview: 'awaitingReview',
};
exports.ViewType = {
    Participant: 'Participant',
    Instructor: 'Instructor',
};
